import {
  useAddContactMutation,
  useUpdateDeskMutation,
  DeskDocument,
  GetPeopleDocument,
  CallRecordsDocument,
} from '../generated/graphql';
import { notify } from 'react-notify-toast';
import { useApolloClient } from '@apollo/client';

export default function useAddCallContact() {
  const apolloClient = useApolloClient();
  const [addContactMutation] = useAddContactMutation({
    refetchQueries: [GetPeopleDocument],
    awaitRefetchQueries: true,
  });
  const [updateDeskMutation] = useUpdateDeskMutation({
    refetchQueries: [DeskDocument],
    awaitRefetchQueries: true,
  });

  async function addCallContact(data) {
    const isPersonalOrDeskContact =
      data?.isPersonalContact ||
      data?.recipient?.type?.includes('Desk') ||
      data?.recipient?.type?.includes('Personal');

    // Add the new contact
    if (data?.recipient || isPersonalOrDeskContact) {
      const contactAlreadyExists = data.recipient?.contacts?.some(
        (contact) => contact.contact === data.contact.contact
      );

      if (!contactAlreadyExists) {
        const contact = {
          contact: data?.contact?.contact,
          contactType: data?.contact?.contactType,
          description: data?.contact?.description,
          primary: data?.contact?.primary,
          private: data?.contact?.private,
          source: data?.contact?.source,
        };

        try {
          if (isPersonalOrDeskContact) {
            // Update desk contacts (Personal or Desk type)
            const { data: updateDeskData } = await updateDeskMutation({
              variables: {
                id: data.deskId,
                input: {
                  addressBook: {
                    name: data.recipient?.name || data.recipientName,
                    contact,
                  },
                },
              },
            });
            if (!updateDeskData?.updateDesk?.success) {
              throw new Error(updateDeskData?.updateDesk?.message || 'Failed to add desk contact');
            }
          } else if (data?.recipient?._id) {
            // Add contact to Person
            const { data: addContactData } = await addContactMutation({
              variables: {
                personId: data?.recipient?._id,
                input: contact,
              },
            });
            if (!addContactData?.addContact?.success) {
              throw new Error(addContactData?.addContact?.message || 'Failed to add contact');
            }
          }

          // Refetch queries to update the UI with the latest data
          await apolloClient.refetchQueries({
            include: [CallRecordsDocument, DeskDocument],
          });
        } catch (error) {
          console.error('Error adding new contact:', error);
          notify.show('Unable to add the new contact. Please try again later.', 'error');
          return;
        }
      }
    }
  }

  return addCallContact;
}
